import { FaGraduationCap, FaSuitcase } from "react-icons/fa";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Experience = () => {
  return (
    <>
      <section id="experience">
        <h1 className="text-4xl text-center font-light mt-18 mt-10 text-white font-bold ">
          MY WORK EXPERIENCE
        </h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="May 2025 - April 2026"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaSuitcase />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.boothwyn.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/boothwyn.png"
                className="w-50 h-50 block mx-auto"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">
              Software Engineer
            </h4>
            <p>Remote, Pennsylvania</p>
            <p>
              Developed and improved internal systems and tools to streamline workflows,
              enhance efficiency, and support new business features.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="June 2024 - May 2025"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaSuitcase />}
            dateClassName="text-white font-bold size-2xl"
          >
            <img
              src="/logo_images/conquest.png"
              className="w-50 h-50 block mx-auto"
            />
            <h4 className="vertical-timeline-element-subtitle">
              Software Engineer
            </h4>
            <p>Torrington, Connecticut</p>
            <p>
              Designed and delivered client-facing applications, focusing on usability,
              performance, and reliable data handling.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="August 2023 - May 2024"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaSuitcase />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.nbhact.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/nbcares.png"
                className="w-50 h-50 block mx-auto"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">
              Software Engineer 
            </h4>
            <p>New Britain, Connecticut</p>
            <p>
              Optimized a React-based dashboard to improve data retrieval and
              real-time user interactions.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="June 2023 - April 2024"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaSuitcase />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.infosys.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/infosys.png"
                className="w-50 h-50 block mx-auto"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">
              Software Engineer Intern
            </h4>
            <p>Hartford, Connecticut</p>
            <p>
              Worked in a team to create an artificial intelligence system for a
              client.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="January 2023 - May 2023"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaSuitcase />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.jobsforhumanity.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/jbf.png"
                className="w-50 h-50 block mx-auto"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">
              Software Engineer Intern
            </h4>
            <p>Remote, New York</p>
            <p>
              Engineered a job mailing system for disadvantaged individuals.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work "
            contentStyle={{
              background: "rgb(33, 150, 243)",
              color: "#fff",
              paddingTop: "50px",
            }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="May 2022 - November 2022"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaSuitcase />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.aps-tech.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/aps.png"
                className="w-50 h-50 block mx-auto -mt-8 mb-2"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">I.T. Intern</h4>
            <p>Wallingford, Connecticut</p>
            <p>
              Worked on various tasks within the I.T. department. I learned how
              to troubleshoot computer issues and how to work with a team to
              solve problems.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>

        <h1 className="text-4xl text-center font-light mt-20 text-white font-bold">
          MY EDUCATION
        </h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="January 2024 - May 2025"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaGraduationCap />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.ccsu.edu"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/ccsu.png"
                className="w-50 h-50 block mx-auto"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">
              Master's in Software Engineering
            </h4>
            <p>New Britain, Connecticut</p>
            <p className="vertical-timeline-element-subtitle"> GPA: 3.90</p>
            <p>ABET accredited.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="January 2019 - December 2023"
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<FaGraduationCap />}
            dateClassName="text-white font-bold size-2xl"
          >
            <a
              href="https://www.ccsu.edu"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logo_images/ccsu.png"
                className="w-50 h-50 block mx-auto"
              />
            </a>
            <h4 className="vertical-timeline-element-subtitle">
              Bachelor's in Computer Science Honors
            </h4>
            <p>New Britain, Connecticut</p>
            <p>Vice President of Computer Science Club</p>
            <p>ABET accredited.</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </section>
    </>
  );
};

export default Experience;
